module.exports = __webpack_public_path__ + "img/20190611_113036_012.60009f2b.jpg";